import {
  Gauge,
  Calculator,
  Dices,
  DollarSign,
  Scale,
  GraduationCap,
  Gift,
  BarChart3,
  LayoutGrid,
  Crosshair,
  Home,
} from "lucide-react";
import { WhaleIcon } from "@/components/icons/whale-icon";
import { CALCULATORS } from "@/components/calculators/registry";

export type NavItem = {
  label: string;
  href: string;
  icon?: React.ComponentType<any>;
  shortLabel?: string;
  children?: NavItem[];
};

export type NavGroup = {
  label: string;
  items: NavItem[];
};

export const HOME_NAV_ITEM: NavItem = {
  label: "Home",
  shortLabel: "Home",
  href: "/home",
  icon: Home,
};

export const FANTASY_PROPS_NAV_ITEM = {
  label: "Fantasy Props",
  shortLabel: "Fantasy",
  href: "/optimizer/props",
  icon: Dices,
} satisfies NavItem;

export const OPTIMIZER_NAV_ITEM = {
  label: "Optimizer",
  shortLabel: "Optimizer",
  href: "/optimizer",
  icon: Gauge,
} satisfies NavItem;

export const EV_SNIPER_NAV_ITEM = {
  label: "+EV Sniper",
  shortLabel: "Sniper",
  href: "/ev-sniper",
  icon: Crosshair,
} satisfies NavItem;

export const ARBITRAGE_NAV_ITEM: NavItem = {
  label: "Arbitrage",
  shortLabel: "Arb",
  href: "/arbitrage",
  icon: Scale,
};

export const WHALE_WATCH_NAV_ITEM = {
  label: "Whale Watch",
  shortLabel: "Whale",
  href: "/whale-watch",
  icon: WhaleIcon,
} satisfies NavItem;

export const NAV_GROUPS: NavGroup[] = [
  {
    label: "Find Edges",
    items: [
      FANTASY_PROPS_NAV_ITEM,
      OPTIMIZER_NAV_ITEM,
      EV_SNIPER_NAV_ITEM,
      ARBITRAGE_NAV_ITEM,
      { label: "Low Hold", shortLabel: "Low Hold", href: "/low-hold", icon: DollarSign },
    ],
  },
  {
    label: "Follow Money",
    items: [
      WHALE_WATCH_NAV_ITEM,
      { label: "Prop Discrepancies", shortLabel: "Props", href: "/prop-discrepancies", icon: BarChart3 },
    ],
  },
  {
    label: "Utilities",
    items: [
      { label: "Odds Screen", shortLabel: "Odds", href: "/odds-screen", icon: LayoutGrid },
      {
        label: "Calculators",
        shortLabel: "Calcs",
        href: "/calculators",
        icon: Calculator,
        children: CALCULATORS.map(({ label, href }) => ({ label, href })),
      },
      { label: "Promos", shortLabel: "Promos", href: "/promos", icon: Gift },
    ],
  },
  {
    label: "Learn",
    items: [
      { label: "Learning Center", shortLabel: "Learn", href: "/learning-center", icon: GraduationCap },
    ],
  },
];
